import { Component, ViewChild } from '@angular/core';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { process, State, toODataString } from '@progress/kendo-data-query';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { LoaderService } from '../../core/services/loader.service';
import { Store, select } from '@ngrx/store';
import { SharedService } from '../../shared/shared.service';

import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { Injectable } from '@angular/core';
import { SweetAlertIcon } from '../../shared/constants/enum';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { table_pageSize } from '../../shared/modals/common';
import {
  getEb_Dg_Status,
  getAllElectricStatus,
} from '../../store/iot-readings/iot-readings.actions';
import {
  getAllElectricStatusResponse,
  getAllEb_Dg_StatusResponse,
} from '../../store/iot-readings/iot-readings-selector';
import {
  getAllEb_Dg_Status,
  getElectricStatus,
} from '../../store/iot-readings/iot-readings.actions';
import {
  getEb_Dg_StatusResponse,
  getElectricStatusResponse,
} from '../../store/iot-readings/iot-readings-selector';
import _ from 'lodash';
@Component({
  selector: 'app-iot-electricity-status',
  templateUrl: './iot-electricity-status.component.html',
  styleUrl: './iot-electricity-status.component.scss',
})
export class IotElectricStuatsComponent {
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  electricStatussList: any = [];
  breadCrumbItems = [{ label: 'Electricity status' }];
  public electricStatusgridData: GridDataResult = { data: [], total: 0 };
  selectableSettings = this.sharedService.selectableSettings;

  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;
  public previousNext = true;

  public pageSize = 10;
  public eb_dg_statusPageSize = 10;
  public skip = 0;
  public eb_dg_statusskip = 0;
  totalelectricStatusCount: number = 0;
  currentPage: number = 1;
  eb_dg_statusCurrentPage: number = 1;

  modalRef!: BsModalRef;
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;

  public electricStatusstate: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public eb_dg_statusstate: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  @ViewChild('electricStatusGrid') public electricStatushiddenGrid:
    | GridComponent
    | undefined;
  @ViewChild('eb_dg_statusGrid') public eb_dg_statushiddenGrid:
    | GridComponent
    | undefined;
  public sort: SortDescriptor[] = [];
  public eb_dg_statussgridData: GridDataResult = { data: [], total: 0 };
  eb_dg_statussList: any = [];
  totaleb_dg_statussCount: number = 0;
  mySelectionelectricStatuss: any = [];
  mySelectioneb_dg_status: any = [];
  queryString: string = '';
  orderByQuery: string = '';
  filterqueryString: string = '';
  eb_dg_statusOrderByQuery: string = '';
  searchedelectricStatusValue: string = '';
  searchedeb_dg_statusValue: string = '';
  allelectricStatussList: any[] = [];
  alleb_dg_statusList: any[] = [];
  constructor(
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private store: Store,
    private sharedService: SharedService
  ) {
    this.getStoreInfo();
    this.selectableSettings = this.sharedService.selectableSettings;
  }

  protected electricStatusPageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1; // Calculate current page
    this.getelectricStatussData(); // Load data for the current page
  }

  protected dataStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadelectricStatuss();
  }

  protected eb_dg_statusdataStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadeb_dg_statuss();
  }

  private loadelectricStatuss(): void {
    const state: State = {
      take: this.pageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };

    const processedData = process(this.electricStatussList, state);
    this.electricStatusgridData = {
      data: processedData.data,
      total: this.totalelectricStatusCount,
    };
    this.electricStatusgridData.data = this.electricStatusgridData?.data.map((item) => {
      // console.log(new Date(project.currentDate));
      return {
        ...item,
        date_on: item?.date ? this.sharedService.dateFormateChnage(item?.date) : '-', // Modify the billDate property
       
      };
    });
    console.log('this.electricStatusgridData', this.electricStatusgridData);
  }

  private loadeb_dg_statuss(): void {
    const state: State = {
      // skip: this.skip,
      take: this.eb_dg_statusPageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };

    const processedData = process(this.eb_dg_statussList, state);
    // this.eb_dg_statussgridData = {
    //   data: this.eb_dg_statussList,
    //   total: this.totaleb_dg_statussCount,
    // };
    this.eb_dg_statussgridData = {
      data: processedData.data,
      total: this.totaleb_dg_statussCount,
    };
    this.eb_dg_statussgridData.data = this.eb_dg_statussgridData?.data.map((item) => {
      return {
        ...item,
        date_on: item?.date ? this.sharedService.dateFormateChnage(item?.date) : '-', // Modify the billDate property
      };
    });
    console.log('this.eb_dg_statussgridData', this.eb_dg_statussgridData);
  }

  protected eb_dg_statusPageChange({ skip, take }: PageChangeEvent): void {
    this.eb_dg_statusskip = skip;
    this.eb_dg_statusPageSize = take;
    this.eb_dg_statusCurrentPage = Math.floor(skip / take) + 1; // Calculate current page
    this.geteb_dg_statussData(); // Load data for the current page
  }

  oneb_dg_statusFilter(value: any): void {
    this.triggerSearcheb();
    // const inputValue = value;
    // this.searchedeb_dg_statusValue = value;
   // this.eb_dg_statusPageChange({ skip: 0, take: this.eb_dg_statusPageSize });
    // this.geteb_dg_statussData();
  }
  onSearcheb(){
    this.triggerSearcheb();
  }
  public onelectricStatusFilter(value: any): void {
    this.triggerSearch();
    // const inputValue = value;
    // this.searchedelectricStatusValue = value;
   // this.electricStatusPageChange({ skip: 0, take: this.pageSize });
    // this.getelectricStatussData();
  }

  ngOnInit(): void {
    this.getAllConfigData();
    this.getelectricStatussData();
    this.geteb_dg_statussData();
  }

  getAllConfigData(): void {
    this.sharedService.getAllConfigData().subscribe((data) => {
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
      }
    });
  }

  getelectricStatussData() {
    this.store.dispatch(
      getElectricStatus({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedelectricStatusValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
    );
  }

  getAllelectricStatussData() {
    this.store.dispatch(
      getAllElectricStatus({
        pageIndex: 1,
        pageSize: this.totalelectricStatusCount,
        searchTerm: this.searchedelectricStatusValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
    );
  }

  geteb_dg_statussData() {
    this.store.dispatch(
      getEb_Dg_Status({
        pageIndex: this.eb_dg_statusCurrentPage,
        pageSize: this.eb_dg_statusPageSize,
        searchTerm: this.searchedeb_dg_statusValue,
        filter: this.filterqueryString,
        orderBy: this.eb_dg_statusOrderByQuery,
      })
    );
  }

  getAlleb_dg_statussData() {
    this.store.dispatch(
      getAllEb_Dg_Status({
        pageIndex: this.currentPage,
        pageSize: this.totaleb_dg_statussCount,
        searchTerm: this.searchedeb_dg_statusValue,
        filter: this.filterqueryString,
        orderBy: this.eb_dg_statusOrderByQuery,
      })
    );
  }

  getStoreInfo() {
    let getelectricStatuss$ = this.store.pipe(
      select(getElectricStatusResponse)
    );
    let getAllelectricStatusResponse$ = this.store.pipe(
      select(getAllElectricStatusResponse)
    );

    let geteb_dg_statuss$ = this.store.pipe(select(getEb_Dg_StatusResponse));
    let getAlleb_dg_statussResponse$ = this.store.pipe(
      select(getAllEb_Dg_StatusResponse)
    );
    // console.log(this.sendOtpResponse$);

    getelectricStatuss$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.electricStatussList = [...res.items];
        this.pageSize = res.pageSize;
        this.totalelectricStatusCount = res.totalCount; // Ensure total count is updated correctly
      }
      this.loadelectricStatuss();
    });

    getAllelectricStatusResponse$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.allelectricStatussList = [...res.items];
      }
      console.log('AllelectricStatussList', res, this.allelectricStatussList);
    });

    getAlleb_dg_statussResponse$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.alleb_dg_statusList = [...res.items];
      }
      console.log('getAlleb_dg_statussResponse', res, this.alleb_dg_statusList);
    });

    geteb_dg_statuss$.subscribe((res: any) => {
      this.loaderService.setLoading(false);
      if (res) {
        this.eb_dg_statussList = [...res.items];
        this.eb_dg_statusPageSize = res.pageSize;
        this.totaleb_dg_statussCount = res.totalCount; // Ensure total count is updated correctly
      }
      this.loadeb_dg_statuss();
    });
  }
  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async onFilterChange(filter: CompositeFilterDescriptor) {
    this.electricStatusstate.filter = filter;
    console.log(this.electricStatusstate);

    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.electricStatusstate);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.electricStatusstate
    );
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        //   console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          //    console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }

    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }

    // this.queryString = this.sharedService.createQuery(this.electricStatusstate);
    this.getelectricStatussData();
    console.log(this.queryString);
  }
  onSortChange(sort: SortDescriptor[], type: string): void {
    if (type == 'electricStatus') {
      this.electricStatusstate.sort = sort;
      console.log(this.electricStatusstate.sort);
      const orderByQuery = this.sharedService.createOrderByQuery(
        this.electricStatusstate.sort
      );

      this.orderByQuery = orderByQuery;
      this.getelectricStatussData();
    } else {
      this.eb_dg_statusstate.sort = sort;
      console.log(this.electricStatusstate.sort);
      const orderByQuery = this.sharedService.createOrderByQuery(
        this.eb_dg_statusstate.sort
      );

      this.eb_dg_statusOrderByQuery = orderByQuery;
      this.geteb_dg_statussData();
    }
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;

    // Check if the element is a table cell or has the class 'k-column-title'
    if (
      (element.nodeName === 'TD' && !element.closest('.no-tooltip')) ||
      element.classList.contains('k-column-title')
    ) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }
  public oneb_dg_customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  oneb_dg_customDateFiltersQueryEq: any[] = [];
  oneb_dg_customDateFiltersQueryNEQ: any[] = [];

  async oneb_dg_statusFilterChange(filter: CompositeFilterDescriptor) {
    this.eb_dg_statusstate.filter = filter;

    this.oneb_dg_customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };

    this.oneb_dg_customFilterState = _.cloneDeep(this.eb_dg_statusstate);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.eb_dg_statusstate
    );
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.oneb_dg_customDateFiltersQueryNEQ = [];

    this.oneb_dg_customDateFiltersQueryEq = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.oneb_dg_customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        //   console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.oneb_dg_customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          //    console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.oneb_dg_customDateFiltersQueryEq = [];
      this.oneb_dg_customDateFiltersQueryNEQ = [];
    }
    if (
      this.oneb_dg_customDateFiltersQueryEq.length > 0 ||
      this.oneb_dg_customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.oneb_dg_customFilterState,
          this.oneb_dg_customDateFiltersQueryEq,
          this.oneb_dg_customDateFiltersQueryNEQ
        );
      this.filterqueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.filterqueryString = this.sharedService.createQuery(
        this.oneb_dg_customFilterState
      );
    }
    this.geteb_dg_statussData();

    /* old */
    /*  console.log(this.eb_dg_statusstate);
    const queryString = this.sharedService.createQuery(this.eb_dg_statusstate);
    this.filterqueryString = this.sharedService.createQuery(
      this.eb_dg_statusstate
    );
   
    console.log(queryString); */
  }

  exportelectricStatus(type: string) {
    /* if (this.mySelectionelectricStatuss.length == 0) {
      this.getAllelectricStatussData();
    } */
    if (type === 'Excel') {
      setTimeout(() => {
        this.electricStatushiddenGrid?.saveAsExcel();
      }, 1000);
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.electricStatushiddenGrid?.saveAsPDF();
      }, 1000);
    }
  }

  exporteb_dg_status(type: string) {
    /* if (this.mySelectionelectricStatuss.length == 0) {
      this.getAlleb_dg_statussData();
    } */
    if (type === 'Excel') {
      setTimeout(() => {
        this.eb_dg_statushiddenGrid?.saveAsExcel();
      }, 1000);
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.eb_dg_statushiddenGrid?.saveAsPDF();
      }, 1000);
    }
  }
  public onelectricStatusPdfExport() {
    this.electricStatushiddenGrid?.saveAsPDF();
  }

  oneb_dg_statusPdfExport() {
    this.eb_dg_statushiddenGrid?.saveAsPDF();
  }
  public iselectricStatusRowSelected = (rowArg: any) => {
    return this.mySelectionelectricStatuss.some(
      (row: any) => row.id === rowArg.id
    );
  };

  public iseb_dg_statusRowSelected = (rowArg: any) => {
    return this.mySelectioneb_dg_status.some(
      (row: any) => row.id === rowArg.id
    );
  };

  public selectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelectionelectricStatuss.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataItem.id
      );
      if (index > -1) {
        this.mySelectionelectricStatuss.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.iselectricStatusRowSelected(row.dataItem)) {
        this.mySelectionelectricStatuss.push(row.dataItem);
      }
    });

    console.log(this.mySelectionelectricStatuss);
  }

  eb_dg_statusselectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelectioneb_dg_status.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataItem.id
      );
      if (index > -1) {
        this.mySelectioneb_dg_status.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.iseb_dg_statusRowSelected(row.dataItem)) {
        this.mySelectioneb_dg_status.push(row.dataItem);
      }
    });

    console.log(this.mySelectioneb_dg_status);
  }

  public clearSearchValueChangeEbDgData(ev: string): void {
    /* if (ev.length == 0) {
      this.electricStatusPageChange({ skip: 0, take: this.pageSize });
    } */
    console.log(ev);
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.electricStatusPageChange({ skip: 0, take: this.pageSize });

    }


  }
  private triggerSearch(): void {
    const trimmedValue = this.searchedelectricStatusValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedelectricStatusValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedelectricStatusValue.length === 0) {
      this.electricStatusPageChange({ skip: 0, take: this.pageSize });
      this.getelectricStatussData()
      return;
    }

    // Otherwise — run search
    this.getelectricStatussData()
  }
  onSearch() {
    this.triggerSearch();
  }
  /*   this.getelectricStatussData();
    this.geteb_dg_statussData(); */

  public clearSearchValueChangeOnOffData(ev: string): void {
   /*  if (ev.length == 0) {
      this.eb_dg_statusPageChange({ skip: 0, take: this.eb_dg_statusPageSize });
    } */
    console.log(ev);
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.eb_dg_statusPageChange({ skip: 0, take: this.eb_dg_statusPageSize });
    }
  }

  private triggerSearcheb(): void {
    const trimmedValue = this.searchedeb_dg_statusValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedeb_dg_statusValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedeb_dg_statusValue.length === 0) {
      this.eb_dg_statusPageChange({ skip: 0, take: this.eb_dg_statusPageSize });
      this.geteb_dg_statussData()
      return;
    }

    // Otherwise — run search
    this.geteb_dg_statussData();
  }
}



// @Injectable()
// export class ProductsService extends NorthwindService {
//     constructor(http: HttpClient) {
//         super(http, 'Products');
//     }

// }
